import { Star, Quote, BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { REVIEWS, REVIEWS_SUMMARY, REVIEWS_INTRO, REVIEWS_ENABLED } from "../data/site";

const Stars = ({ className = "h-4 w-4" }) => (
  <div className="flex gap-0.5 text-gold" aria-label="5 csillag">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className={`${className} fill-current`} />
    ))}
  </div>
);

export const Reviews = () => {
  if (!REVIEWS_ENABLED) return null;
  return (
    <section id="velemenyek" data-testid="reviews-section" className="scroll-mt-24 bg-cream2 py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-12 flex flex-wrap items-center justify-between gap-8">
          <div className="max-w-xl">
            <p className="eyebrow mb-3">{REVIEWS_INTRO.eyebrow}</p>
            <h2 className="font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl">
              {REVIEWS_INTRO.title}
            </h2>
          </div>
          <div
            data-testid="reviews-summary"
            className="flex items-center gap-5 rounded-3xl border border-line bg-white px-7 py-5 card-shadow"
          >
            <div>
              <p className="font-display text-4xl font-semibold text-ink">{REVIEWS_SUMMARY.rating}</p>
              <div className="mt-1">
                <Stars />
              </div>
            </div>
            <div className="border-l border-line pl-5 text-sm leading-snug text-soft">
              <p className="font-bold text-ink">{REVIEWS_SUMMARY.count}</p>
              <p className="mt-0.5 text-xs">{REVIEWS_SUMMARY.sub}</p>
              <p className="mt-1.5 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-burgundy">
                <BadgeCheck className="h-4 w-4" />
                {REVIEWS_SUMMARY.badge}
              </p>
            </div>
          </div>
        </Reveal>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.08}>
              <blockquote
                data-testid={`review-card-${i}`}
                className="flex h-full flex-col rounded-3xl border border-line bg-white p-7 card-shadow transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <Quote className="h-7 w-7 text-burgundy/25" />
                <p className="mt-4 flex-1 text-sm leading-relaxed text-soft">{r.text}</p>
                <footer className="mt-5 flex items-center justify-between border-t border-line pt-4">
                  <div>
                    <p className="text-sm font-bold text-ink">{r.name}</p>
                    <p className="text-xs text-soft">{r.platform}</p>
                  </div>
                  <Stars className="h-3.5 w-3.5" />
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
